import { Box, BoxProps } from '@chakra-ui/react'
import React from 'react'

interface Props extends BoxProps {
  children: React.ReactNode
}

export default function LiveBadge({ position, children, ...restProps }: Props) {
  return (
    <Box
      position="absolute"
      bgColor="gray.700"
      borderRadius="8px"
      padding={['8px', null, null, '16px']}
      fontSize={['xs', null, 'md', 'lg']}
      {...restProps}
    >
      {children}
    </Box>
  )
}
